export default function noop() {}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-geo/src/noop.js
// module id = ../../../../d3-geo/src/noop.js
// module chunks = vendor